import { alpha, styled } from "@mui/material";

interface ContainerProps {
  $showOverlay?: boolean;
  $centerContent?: boolean;
}

export const Container = styled("div")<ContainerProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: ${({ $showOverlay }) => ($showOverlay ? "auto" : "none")};

  ${({ $centerContent }) =>
    $centerContent &&
    `
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  ${({ theme, $showOverlay }) =>
    $showOverlay &&
    `
    background-color: ${alpha(theme.palette.common.black, 0.5)};
  `}

  & > * {
    pointer-events: auto;
  }
`;
